import React from "react";
import { Form, Input, Button, Select, message } from "antd";
import { Api } from "../../../../api/configApi";
import { ObjectId } from "bson";
import { store, setStoreWidgets } from "../../../../store";
import CamposPersonalizados from "./CamposPersonalizados/CamposPersonalizados";

const CrearActualizarWidgetTranferNumeroComponente = (props) => {
  const { Option } = Select;
  const [loading, setLoading] = React.useState(false);
  const [insertOrUpdate, setInsertOrUpdate] = React.useState("InsertWidgets");
  const [form] = Form.useForm();
  const guardarWidget = (values) => {
    //   tipo de widget
    values.tipo = "tranferNumero";
    setLoading(true);
    values.limiteCantidad = +values.limiteCantidad;
    values.limiteWidth = +values.limiteWidth;

    Api("Cuentas", insertOrUpdate, { _id: store.cuentaactiva }, values)
      .then((res) => {
        props.setVisible(false);
        setLoading(false);
        return Api(
          "Cuentas",
          "Get",
          { _id: store.cuentaactiva },
          { widgets: 1 }
        );
      })
      .then((res) => {
        setStoreWidgets(res[0].widgets);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ _id: new ObjectId(), dinamico: false });
  }, [props.visible]);

  React.useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
      setInsertOrUpdate("UpdateWidgets");
    } else {
      form.setFieldsValue({ _id: new ObjectId(), dinamico: false });
    }
  }, [props.data]);

  return (
    <div>
      <Form form={form} onFinish={guardarWidget} layout="vertical">
        <Form.Item
          label="Nombre"
          name="nombre"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un nombre" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="_id" hidden rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="dinamico" hidden rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="Titulo"
          name="titulo"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un titulo" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Descripción"
          name="descripcion"
          hasFeedback
          rules={[{ required: true, message: "Ingresa una descripción" }]}
        >
          <Input />
        </Form.Item>

        {/* Campos personalizados de este WIDGET */}
        <CamposPersonalizados formulario={form} />
        {/* Fin campos personalizados de este Widget... */}

        <Form.Item noStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 15,
            }}
          >
            <Button loading={loading} htmlType="submit">
              Guardar
            </Button>
            <Button
              loading={loading}
              onClick={() => {
                props.setVisible(false);
              }}
              htmlType="button"
            >
              Cancelar
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CrearActualizarWidgetTranferNumeroComponente;
